import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./Pages/Layout/Layout";
import LoginCard from "./Pages/Login/Login";
import PriceSection from "./Pages/Section/PriceSection/PriceSection";
import InsideTemplateSection from "./Pages/Section/InsideTemplate/InsideTemplateSection";
import IndustrieSection from "./Pages/Section/Industries/IndustrieSection";
import FooterSection from "./Pages/Section/FooterSection/FooterSection";
import TermCondition from "./Pages/Section/FooterSection/TermCondition";
import PrivatePolicy from "./Pages/Section/FooterSection/PrivatePolicy";
import RefundPolicy from "./Pages/Section/FooterSection/RefundPolicy";
import BlogPageSection from "./Pages/Section/BlogSection/BlogPageSection";
import BlogcardSection from "./Pages/Section/BlogSection/BlogcardSection";
import BlogMainSection from "./Pages/Section/BlogSection/BlogMainSection";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Contactus from "./Pages/Section/FooterSection/Contactus";
import AboutUs from "./Pages/Section/FooterSection/AboutUs";
import SiteMap from "./Pages/Section/FooterSection/SiteMap";
import Faq from "./Pages/Section/FooterSection/Faq";
import ScrollToTop from "./Pages/ScrollTop/ScrollToTop";
import CertificateCardDemo from "./Pages/Section/CertificateCard/CertificateCardDemo";
import CardSilderInformation from "./Pages/Section/CardStackScroll/CardSilderInformation";
import NewCustomCard from "./Pages/Header/NewCustomCard";
import Test_com from "./Pages/Layout/Test_com";
import MobileCustomCard2 from "./Pages/Section/VerticalCardScroll/MobileCustomCard2";
import AboutUsComponent from "./Pages/Section/About us/AboutUsComponent";
// import InsideTemplate2 from "./Pages/Section/InsideTemplate/InsideTemplate2";
// import Template1 from "./Pages/Section/TemplateSection/Section15/TemplateData/TemplatePages/Template1";
// import Template2 from "./Pages/Section/TemplateSection/Section15/TemplateData/TemplatePages/Template2/Template2";
import Soution from "./Pages/Section/Solution/Solution1/Soution";
import FourthSectionPage from "./Pages/Section/FourthMainSection/FourthSectionPages/FourthSectionPage";
import MobileCard from "./Pages/Section/FourthMainSection/MainSectionForth/MobileCard";
import MobileCardComponent from "./Pages/Section/FourthMainSection/MainSectionForth/MobileCardComponent";
import TestComponent from "./Pages/Section/TemplateSection/Section15/TestComponent/TestComponent";
import WhatsAppMarketing from "./Pages/Section/Product 1/WhatsAppMarketing/WhatsAppMarketing";
import WhatsAppAdds from "./Pages/Section/Product 1/WhatsAppAdds/WhatsAppAdds";
import WhatsAppChatboat from "./Pages/Section/Product 1/WhatsAppChatboat/WhatsAppChatboat";
import WhatsAppPayment from "./Pages/Section/Product 1/WhatsAppPayment/WhatsAppPayment";
import WhatsAppForm from "./Pages/Section/Product 1/WhatsAppForm/WhatsAppForm";
import WhatsAppWebView from "./Pages/Section/Product 1/WhatsAppWebViews/WhatsAppWebView";
import WhatsAppButton from "./Pages/Section/Product 1/WhatsAppButtons/WhatsAppButton";
import WhatsAppLink from "./Pages/Section/Product 1/WhatsappLink/WhatsAppLink";
import IndustriesPage from "./Pages/Section/IndustriesHeader/IndustriesPage";
// Import BlogContentPage
import BlogContentPage from "./Pages/Section/BlogSection/BlogContentPage";
import TemplateLayout from "./Pages/Section/InsideTemplate/TemplateLayout";
import Template1 from "./Pages/Section/InsideTemplate/Template1";
import Template2 from "./Pages/Section/InsideTemplate/Template2";
import Template3 from "./Pages/Section/InsideTemplate/Template3";
import Template4 from "./Pages/Section/InsideTemplate/Template4";
import Template5 from "./Pages/Section/InsideTemplate/Template5";
import Template6 from "./Pages/Section/InsideTemplate/Template6";
import Template7 from "./Pages/Section/InsideTemplate/Template7";
import Template8 from "./Pages/Section/InsideTemplate/Template8";
import Template9 from "./Pages/Section/InsideTemplate/Template9";
import Template10 from "./Pages/Section/InsideTemplate/Template10";
import Template11 from "./Pages/Section/InsideTemplate/Template11";
import Template12 from "./Pages/Section/InsideTemplate/Template12";

const App = () => {
  // Define the theme
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />} />
          <Route path="/login" element={<LoginCard />} />
          <Route path="/price" element={<PriceSection />} />
          <Route path="/template-details" element={<InsideTemplateSection />} />
          <Route path="/industries-details" element={<IndustrieSection />} />
          <Route path="/footer-section" element={<FooterSection />} />
          <Route path="/policies" element={<TermCondition />} />
          <Route path="/privacy-policy" element={<PrivatePolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/blog-page" element={<BlogPageSection />} />
          <Route path="/blog-component" element={<BlogMainSection />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/about-us" element={<AboutUsComponent />} />
          <Route path="/site-map" element={<SiteMap />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/test12" element={<CertificateCardDemo />} />
          <Route path="/card-info" element={<CardSilderInformation />} />
          <Route path="/new-card" element={<NewCustomCard />} />
          <Route path="/react-compare-image" element={<Test_com />} />
          <Route path="/card2" element={<MobileCustomCard2 />} />
          <Route path="/solution1" element={<Soution />} />
          <Route path="/products" element={<FourthSectionPage />} />
          <Route path="/mobile-card" element={<MobileCardComponent />} />
          <Route path="/test-component" element={<TestComponent />} />
          <Route path="/whatsapp-marketing" element={<WhatsAppMarketing />} />
          <Route path="/whatsapp-adds" element={<WhatsAppAdds />} />
          <Route path="/whatsapp-chatboat" element={<WhatsAppChatboat />} />
          <Route path="/whatsapp-payment" element={<WhatsAppPayment />} />
          <Route path="/whatsapp-form" element={<WhatsAppForm />} />
          <Route path="/whatsapp-webview" element={<WhatsAppWebView />} />
          <Route path="/whatsapp-button" element={<WhatsAppButton />} />
          <Route path="/whatsapp-link" element={<WhatsAppLink />} />
          <Route path="/industries-component/:slug" element={<IndustriesPage />} />
          <Route path="/blog-content/:slug" element={<BlogContentPage />} />
          <Route element={<TemplateLayout />}>
            <Route path="/template1" element={<Template1 />} />
            <Route path="/template2" element={<Template2 />} />
            <Route path="/template3" element={<Template3 />} />
            <Route path="/template4" element={<Template4 />} />
            <Route path="/template5" element={<Template5 />} />
            <Route path="/template6" element={<Template6 />} />
            <Route path="/template7" element={<Template7 />} />
            <Route path="/template8" element={<Template8 />} />
            <Route path="/template9" element={<Template9 />} />
            <Route path="/template10" element={<Template10 />} />
            <Route path="/template11" element={<Template11 />} />
            <Route path="/template12" element={<Template12 />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;

